import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1839ab18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chat-input-bar"
}
const _hoisted_2 = {
  key: 0,
  class: "handlers"
}
const _hoisted_3 = { class: "chat-input-bar-right" }
const _hoisted_4 = {
  key: 0,
  class: "middle-wrapper"
}
const _hoisted_5 = { class: "input-inner-wrapper" }
const _hoisted_6 = {
  key: 1,
  id: "audioPlayerRef",
  class: "audio-recorder-container"
}
const _hoisted_7 = {
  key: 2,
  class: "replying-to-message"
}
const _hoisted_8 = { class: "replying-to-message-inner" }
const _hoisted_9 = { class: "replying-to-message-left" }
const _hoisted_10 = { class: "replying-to-title" }
const _hoisted_11 = {
  key: 0,
  class: "replying-to-text"
}

import InputText from "@/components/chat/chatContainer/InputText/InputText.vue";
import InputAttachment from "@/components/chat/chatContainer/InputAttachment.vue";
import InputAttachmentWithPreview from "@/components/chat/chatContainer/InputAttachmentWithPreview.vue";
import { Profile } from "@/store/auth/state";
import { useGetChatInputBarProperties } from "./useGetChatInputBarProperties";
import { User } from "@/store/users/state";
import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";
import AudioInput from "../AudioInput.vue";
import AudioPlayer from "../AudioPlayer/AudioPlayer.vue";
import EmojisAndGiphs from "@/components/cards/EmojisAndGiphs/EmojisAndGiphs.vue";

interface Props {
  newChat?: boolean;
  alreadyExistsChatId?: string | null;
  members?: Profile[] | User[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatInputBar',
  props: {
    newChat: { type: Boolean, default: false },
    alreadyExistsChatId: { default: "" },
    members: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const {
  data,
  messageInput,
  isInputShown,
  isMobile,
  messageInputHeight,
  toggleShowEmoji,
  addAttachment,
  addMessageText,
  removeAttachment,
  setMessageText,
  sendMessage,
  addGifAttachment,
  clearInjectedMessage,
  // audio recorder handlers
  startRecording,
  clearRecording,
  audioPlayerProps,
  isRecordingOrFinished,
  replyMessage,
  textMessagePreviewText,
  modifyMessage,
} = useGetChatInputBarProperties(props);

return (_ctx: any,_cache: any) => {
  return (_unref(isInputShown))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_unref(isRecordingOrFinished))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!_unref(isMobile))
                ? (_openBlock(), _createBlock(Icon, {
                    key: 0,
                    icon: _unref(IconType).EMOJI,
                    alt: "emoji",
                    class: "emoji-btn",
                    onClick: _unref(toggleShowEmoji)
                  }, null, 8, ["icon", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(InputAttachment, { onAddAttachment: _unref(addAttachment) }, null, 8, ["onAddAttachment"]),
              _createVNode(AudioInput, { onStartRecording: _unref(startRecording) }, null, 8, ["onStartRecording"])
            ]))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "input-attachment",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(clearRecording) && _unref(clearRecording)(...args)))
            }, [
              _createVNode(Icon, {
                icon: _unref(IconType).TRASH,
                alt: "trash-icon",
                class: "clear-btn"
              }, null, 8, ["icon"])
            ])),
        _createElementVNode("div", _hoisted_3, [
          (!_unref(isRecordingOrFinished))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_unref(data).isEmojiShown)
                  ? (_openBlock(), _createBlock(EmojisAndGiphs, {
                      key: 0,
                      onInsertEmoji: _unref(addMessageText),
                      onToggleEmojiListVisibility: _unref(toggleShowEmoji),
                      onInsertGif: _unref(addGifAttachment)
                    }, null, 8, ["onInsertEmoji", "onToggleEmojiListVisibility", "onInsertGif"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "input-wrapper",
                  style: _normalizeStyle({ height: `${_unref(messageInputHeight) - 16}px` })
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(InputAttachmentWithPreview, {
                      attachments: _unref(data).attachments,
                      onAddAttachment: _unref(addAttachment),
                      onRemoveAttachment: _unref(removeAttachment)
                    }, null, 8, ["attachments", "onAddAttachment", "onRemoveAttachment"]),
                    _createVNode(InputText, {
                      ref_key: "messageInput",
                      ref: messageInput,
                      text: _unref(data).messageText,
                      attachments: _unref(data).attachments,
                      onUpdateText: _unref(setMessageText),
                      onSendMessage: _unref(sendMessage)
                    }, null, 8, ["text", "attachments", "onUpdateText", "onSendMessage"])
                  ]),
                  (_unref(isMobile))
                    ? (_openBlock(), _createBlock(Icon, {
                        key: 0,
                        icon: _unref(IconType).EMOJI,
                        alt: "emoji",
                        class: "emoji-btn",
                        onClick: _unref(toggleShowEmoji)
                      }, null, 8, ["icon", "onClick"]))
                    : _createCommentVNode("", true)
                ], 4)
              ]))
            : _createCommentVNode("", true),
          (_unref(audioPlayerProps).isShown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(AudioPlayer, _normalizeProps(_guardReactiveProps(_unref(audioPlayerProps))), null, 16)
              ]))
            : _createCommentVNode("", true),
          _createVNode(Icon, {
            icon: _unref(IconType).SEND,
            class: "icon-send",
            onClick: _unref(sendMessage)
          }, null, 8, ["icon", "onClick"]),
          (!!_unref(replyMessage) || !!_unref(modifyMessage))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(replyMessage)
                ? _ctx.$t("chat.chatContainer.messages.replies.youAreReplyingTo", {
                    replyToSenderName: _unref(replyMessage)?.senderName,
                  })
                : _ctx.$t("chat.chatContainer.messages.editing.modifyMessage")), 1),
                    (_unref(textMessagePreviewText) && !_unref(modifyMessage))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(textMessagePreviewText)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: "replying-to-close",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(clearInjectedMessage) && _unref(clearInjectedMessage)(...args)))
                  }, [
                    _createVNode(Icon, {
                      icon: _unref(IconType).CROSS_GREY_CIRCLE
                    }, null, 8, ["icon"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})